import { colors } from '../../colors';
var select = {
  arrowColor: colors.nvaTeal,
  textColor: colors.nvaBlack,
  borderColor: colors.nvaBlack,
  backgroundColor: colors.white
};
export default select;